const ARIA_LABEL_CLEAR_KEY = "arialabelclear";
const ARIA_LABEL_INPUT_KEY = "arialabelinput";
const ARIA_LABEL_SEARCH_KEY = "arialabelsearch";
const COMPONENT_NAME = "SearchBarUI";
const DEBOUNCE_TIME = 500;
const ERROR_TEXT_KEY = "errortext";
const GRS_AUTOSUGGEST_SERVICE_CONFIG_DEVELOPMENT_KEY = "typeahead_autosuggest_api_service_config";
const GRS_SEARCH_SERVICE_CONFIG_DEVELOPMENT_KEY = "keyword_search_api_service_config";
const GRS_PRODUCT_TYPE_PHARMACY = "PHARMACY";
const GRS_PRODUCT_TYPE_TRAVEL = "TRAVEL";
const GRS_PROVIDER_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY = "grs_provider_feature_toggle";
const GRS_PROVIDER_BETA_RELEASE_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY = "grs_beta_release_enabled";
const GRS_VISITOR_ID_FALLBACK = "fallbackVisitorId";
const LIST_BOX_ARIA_LABEL_KEY = "arialabellistbox";
const SEARCH_FIELD_DESCRIPTION_KEY = "searchfielddescription";
const PHARMACY_PLACEHOLDER_IMAGE_KEY = "pharmacyImage";
const PLACEHOLDER_TEXT_KEY = "placeholdertext";
const REFINE_PARAMETER_SUFFIX_KEY = "refineParameterSuffix";
const SEARCH_BAR_MODULE_SETTINGS_DEVELOPER_KEY = "search_bar";
const SEARCH_URL_KEY = "searchURL";
const SUGGESTIONS_LIST_ID = "suggestions-list";
const SEARCH_FIELD_DESCRIPTION_ID = "typeahead-search-field-description";
const TYPEAHEAD_SERVICE_CONFIG_DEVELOPMENT_KEY = "typeaheadServiceConfigKey";
const SEARCH_KEYWORD_PARAM = "keyword";
export {
  ARIA_LABEL_CLEAR_KEY,
  ARIA_LABEL_INPUT_KEY,
  ARIA_LABEL_SEARCH_KEY,
  COMPONENT_NAME,
  DEBOUNCE_TIME,
  ERROR_TEXT_KEY,
  GRS_AUTOSUGGEST_SERVICE_CONFIG_DEVELOPMENT_KEY,
  GRS_PRODUCT_TYPE_PHARMACY,
  GRS_PRODUCT_TYPE_TRAVEL,
  GRS_PROVIDER_BETA_RELEASE_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY,
  GRS_PROVIDER_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY,
  GRS_SEARCH_SERVICE_CONFIG_DEVELOPMENT_KEY,
  GRS_VISITOR_ID_FALLBACK,
  LIST_BOX_ARIA_LABEL_KEY,
  PHARMACY_PLACEHOLDER_IMAGE_KEY,
  PLACEHOLDER_TEXT_KEY,
  REFINE_PARAMETER_SUFFIX_KEY,
  SEARCH_BAR_MODULE_SETTINGS_DEVELOPER_KEY,
  SEARCH_FIELD_DESCRIPTION_ID,
  SEARCH_FIELD_DESCRIPTION_KEY,
  SEARCH_KEYWORD_PARAM,
  SEARCH_URL_KEY,
  SUGGESTIONS_LIST_ID,
  TYPEAHEAD_SERVICE_CONFIG_DEVELOPMENT_KEY
};
